<mat-card>
  <mat-card-title>
    <button mat-fab class="pull-right" (click)="openCreateDialog()">
      <mat-icon class="md-24">add</mat-icon>
    </button>
    Kalender
  </mat-card-title>
  <mat-card-content>
    <p-schedule [events]="events" (onDayClick)="openCreateDialog($event)" [header]="headerConfig"
                (onEventClick)="viewAppointment($event)" locale="de-at" (onViewRender)="loadEvents($event)"></p-schedule>
  </mat-card-content>
</mat-card>



// WEBPACK FOOTER //
// /home/markush/Projects/fieldsale-wingman-client/src/app/calendar/calendar.component.html